import store from 'sky-engine/store'

import adapter from './modules/adapter'
import areaIndustryUserMng from './modules/areaIndustryUserMng'
import batchMaintenance from './modules/batchMaintenance'
import calSoftwareMng from './modules/calSoftwareMng'
import caseBusiMng from './modules/caseBusiMng'
import caseMng from './modules/caseMng'
import casePeripheralMng from './modules/casePeripheralMng'
import caseRepo from './modules/caseRepo'
import caseSoftwareMng from './modules/caseSoftwareMng'
import channelMng from './modules/channelMng'
import common from './modules/common'
import compatiblePeripheralMng from './modules/compatibleMng/peripheralMng'
import compatibleSoftwareMng from './modules/compatibleMng/softwareMng'
import copyFeatureAndTestCaseMng from './modules/copyProductMng'
import copyScene from './modules/copyScene'
import deliveryDeployMng from './modules/deliveryDeployMng'
import deliveryGuideMng from './modules/deliveryGuideMng'
import desktopElementMng from './modules/desktopElementMng'
import featureLimitMng from './modules/featureLimitMng'
import feature from './modules/featureMng'
import featureValueMng from './modules/featureValueMng'
import feedbackCollectMng from './modules/feedbackCollectMng'
import feedbackMng from './modules/feedbackMng'
import gpuCardMng from './modules/gpuCardMng'
import industryMng from './modules/industryMng'
import limitMng from './modules/limitMng'
import npsMng from './modules/npsMng'
import osTypeMng from './modules/osTypeMng'
import peripheralMng from './modules/peripheralMng'
import permission from './modules/permission'
import pocMng from './modules/pocMng'
import positionMng from './modules/positionMng'
import productMng from './modules/productMng'
import productStrategyMng from './modules/productStrategyMng'
import reportMng from './modules/reportMng'
import reportQryMng from './modules/reportQryMng'
import sceneDirMng from './modules/sceneDirMng'
import sceneMng from './modules/sceneMng'
import segmentSceneMng from './modules/segmentSceneMng'
import serverCalculatorMng from './modules/serverCalculatorMng'
import serverMng from './modules/serverMng'
import softwareBlackListMng from './modules/softwareBlackListMng'
import softwareMng from './modules/softwareMng'
import systemSettingMng from './modules/systemSettingMng'
import terminalMng from './modules/terminalMng'
import toBeDeliveryDeployMng from './modules/toBeDeliveryDeployMng'
import toolMng from './modules/toolMng'
import user from './modules/user'
import userMng from './modules/userMng'

const modules = {
  common,
  positionMng,
  areaIndustryUserMng,
  featureValueMng,
  deliveryGuideMng,
  adapter,
  permission,
  user,
  caseMng,
  compatiblePeripheralMng,
  compatibleSoftwareMng,
  copyFeatureAndTestCaseMng,
  deliveryDeployMng,
  toBeDeliveryDeployMng,
  feature,
  feedbackMng,
  feedbackCollectMng,
  pocMng,
  caseRepo,
  reportMng,
  reportQryMng,
  sceneMng,
  industryMng,
  peripheralMng,
  softwareMng,
  softwareBlackListMng,
  userMng,
  caseSoftwareMng,
  casePeripheralMng,
  caseBusiMng,
  osTypeMng,
  serverMng,
  terminalMng,
  productMng,
  productStrategyMng,
  toolMng,
  featureLimitMng,
  serverCalculatorMng,
  limitMng,
  systemSettingMng,
  npsMng,
  channelMng,
  gpuCardMng,
  desktopElementMng,
  segmentSceneMng,
  batchMaintenance,
  copyScene,
  calSoftwareMng,
  sceneDirMng
}

for (const key in modules) {
  // eslint-disable-next-line no-prototype-builtins
  if (modules.hasOwnProperty(key)) {
    store.registerModule(key, modules[key])
  }
}

export default store
